import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { Template } from "../Template";

export const AnalyzingDataStep = () => {
  return (
    <Template
      leftNode={
        <Grid
          container
          item
          direction={"row"}
          columnSpacing={1}
          alignItems={"center"}
          sx={{ height: "100%" }}
        >
          <Grid item>
            <IgTypography sx={{ fontWeight: 600, fontSize: "18px" }}>
              Analyzing results...
            </IgTypography>
          </Grid>
        </Grid>
      }
    />
  );
};
